export enum PartyType {
  ENTITY = 'ENTITY',
  PERSON = 'PERSON',
  UNKNOWN = 'UNKNOWN',
}

export enum MarginType {
  PM_MASTER = 'PM_MASTER',
  PM_SUB = 'PM_SUB',
  JBO_MASTER = 'JBO_MASTER',
  JBO_SUB = 'JBO_SUB',
  REG_T = 'REG_T',
}

export enum AccountRegistration {
  ENTITY_LITE = 'ENTITY_LITE',
  BUSINESS_TRUST = 'BUSINESS_TRUST',
  COMMUNITY_PROPERTY = 'COMMUNITY_PROPERTY',
  CUSTODIAN = 'CUSTODIAN',
  CORPORATION = 'CORPORATION',
  EXECUTOR_ADMINISTRATOR = 'EXECUTOR_ADMINISTRATOR',
  CLOSED_ACCOUNT = 'CLOSED_ACCOUNT',
  FIRM_ACCOUNT = 'FIRM_ACCOUNT',
  PRIME_BROKER = 'PRIME_BROKER',
  GUARDIAN_COMMITTEEMAN_CONSERVATOR = 'GUARDIAN_COMMITTEEMAN_CONSERVATOR',
  INDIVIDUAL_LEGACY = 'INDIVIDUAL_LEGACY',
  INDIVIDUAL = 'INDIVIDUAL',
  INVESTMENT_CLUB = 'INVESTMENT_CLUB',
  JTWROS = 'JTWROS',
  JTTENCOM = 'JTTENCOM',
  PARTNERSHIP = 'PARTNERSHIP',
  OTHER_IRA = 'OTHER_IRA',
  APEX_IRA = 'APEX_IRA',
  IRA_SPOUSE = 'IRA_SPOUSE',
  APEX_ROLLOVER_IRA = 'APEX_ROLLOVER_IRA',
  SEP_EMPLOYER_IRA = 'SEP_EMPLOYER_IRA',
  APEX_SEP_IRA = 'APEX_SEP_IRA',
  APEX_ROTH_IRA = 'APEX_ROTH_IRA',
  PLAN_TERMINATED_IRA = 'PLAN_TERMINATED_IRA',
  IRA_PARTICIPANT_MATURED = 'IRA_PARTICIPANT_MATURED',
  APEX_COVERDELL_EDUCATION_IRA = 'APEX_COVERDELL_EDUCATION_IRA',
  SBJCT_TO_DISABILITY_PYMT_IRA = 'SBJCT_TO_DISABILITY_PYMT_IRA',
  SBJCT_TO_DEATH_IRA = 'SBJCT_TO_DEATH_IRA',
  EMPLOYEE_IRA = 'EMPLOYEE_IRA',
  EMPLOYEE_SPOUSE_IRA = 'EMPLOYEE_SPOUSE_IRA',
  INDIVIDUAL_401K = 'INDIVIDUAL_401K',
  APEX_MONEY_PRCHSE_PENSION_PL = 'APEX_MONEY_PRCHSE_PENSION_PL',
  APEX_SIMPLE_IRA = 'APEX_SIMPLE_IRA',
  APEX_PROFIT_SHARING_PLAN = 'APEX_PROFIT_SHARING_PLAN',
  TERMINATED_401K = 'TERMINATED_401K',
  PREMATURE_EXCEPTION_IRA = 'PREMATURE_EXCEPTION_IRA',
  SIMPLE_401K = 'SIMPLE_401K',
  APEX_BENEFICIARY_IRA = 'APEX_BENEFICIARY_IRA',
  DESIGNATED_ROTH_401K = 'DESIGNATED_ROTH_401K',
  ROTH_CONVERSION_IRA = 'ROTH_CONVERSION_IRA',
  SOLE_PROPRIETORSHIP = 'SOLE_PROPRIETORSHIP',
  TRUSTEE_TESTAMENTARY = 'TRUSTEE_TESTAMENTARY',
  TRUSTEE_LIVING_TRUST = 'TRUSTEE_LIVING_TRUST',
  TRUSTEE_U_AGREEMENT = 'TRUSTEE_U_AGREEMENT',
  UN_INCORP_ASSOC = 'UN_INCORP_ASSOC',
  JTTEN_ENT = 'JTTEN_ENT',
  DVP_INST_EXEC_BROKER = 'DVP_INST_EXEC_BROKER',
  APEX_BROKER = 'APEX_BROKER',
  OMNIBUS_DOMESTIC = 'OMNIBUS_DOMESTIC',
  JBO_ACCOUNT = 'JBO_ACCOUNT',
  RETIREMENT_PLAN = 'RETIREMENT_PLAN',
  LIMITED_LIABILITY = 'LIMITED_LIABILITY',
  TOD_INDIVIDUAL = 'TOD_INDIVIDUAL',
  TOD_JTWROS = 'TOD_JTWROS',
  FOREIGN_ESTATE = 'FOREIGN_ESTATE',
  FOREIGN_JOINT = 'FOREIGN_JOINT',
  FOREIGN_CORPORATION = 'FOREIGN_CORPORATION',
  FOREIGN_GUARDIAN = 'FOREIGN_GUARDIAN',
  FOREIGN_INDIVIDUAL = 'FOREIGN_INDIVIDUAL',
  FOREIGN_INVESTMENT_CLUB = 'FOREIGN_INVESTMENT_CLUB',
  FOREIGN_BANK_CORP = 'FOREIGN_BANK_CORP',
  FOREIGN_FINANCIAL_INST_CORP = 'FOREIGN_FINANCIAL_INST_CORP',
  FOREIGN_JTTENCOM = 'FOREIGN_JTTENCOM',
  FOREIGN_PARTNERSHIP = 'FOREIGN_PARTNERSHIP',
  FOREIGN_JTWROS = 'FOREIGN_JTWROS',
  FOREIGN_TRUST = 'FOREIGN_TRUST',
  FOREIGN_BUSINESS_TRUST = 'FOREIGN_BUSINESS_TRUST',
  FOREIGN_NON_CORP = 'FOREIGN_NON_CORP',
  FOREIGN_JTTEN_ENT = 'FOREIGN_JTTEN_ENT',
  FOREIGN_BANK_LLC = 'FOREIGN_BANK_LLC',
  FOREIGN_BANK_PARTNERSHIP = 'FOREIGN_BANK_PARTNERSHIP',
  FOREIGN_FINANCIAL_INST_LLC = 'FOREIGN_FINANCIAL_INST_LLC',
  FOREIGN_FINANCIAL_INST_PARTNERSHIP = 'FOREIGN_FINANCIAL_INST_PARTNERSHIP',
  FOREIGN_CONSOLIDATED = 'FOREIGN_CONSOLIDATED',
  FOREIGN_DVP = 'FOREIGN_DVP',
  FOREIGN_APEX_BROKER = 'FOREIGN_APEX_BROKER',
  FOREIGN_OMNIBUS = 'FOREIGN_OMNIBUS',
  FOREIGN_LIMITED_LIABILITY = 'FOREIGN_LIMITED_LIABILITY',
  DOMESTIC_MASTER_SUB = 'DOMESTIC_MASTER_SUB',
  FOREIGN_MASTER_SUB = 'FOREIGN_MASTER_SUB',
  UNKNOWN = 'UNKNOWN',
}

export enum PabType {
  AVERAGE_PRICE = 'AVERAGE_PRICE',
  DAY_TRADING = 'DAY_TRADING',
  EXECUTION_ONLY = 'EXECUTION_ONLY',
  MARKET_MAKER = 'MARKET_MAKER',
  RISKLESS_PRINCIPAL = 'RISKLESS_PRINCIPAL',
  SYNDICATE = 'SYNDICATE',
  TRADING = 'TRADING',
  TEST = 'TEST',
  WORTHLESS_SECURITIES = 'WORTHLESS_SECURITIES',
  PNL_SWEEP = 'PNL_SWEEP',
  WRITE_OFF = 'WRITE_OFF',
  COMMISSION = 'COMMISSION',
  RIA_FEE = 'RIA_FEE',
  FEE = 'FEE',
  ERROR = 'ERROR',
  GOOD_FAITH_DEPOSIT = 'GOOD_FAITH_DEPOSIT',
  OTHER = 'OTHER',
}

export enum TaxStatus {
  NONE = 'NONE',
}

export enum TaxWithholdingStatus {
  IRA_NO_WH_NO_1099_EXCEPT_SUB_PMNT = 'IRA_NO_WH_NO_1099_EXCEPT_SUB_PMNT',
  DVP_NO_WH_NO_1099_EXCEPT_SUB_PMNT = 'DVP_NO_WH_NO_1099_EXCEPT_SUB_PMNT',
  W9_ON_FILE_CERTIFIED = 'W9_ON_FILE_CERTIFIED',
  W8_ON_FILE_CERTIFIED = 'W8_ON_FILE_CERTIFIED',
  NO_W8_SUBJ_TO_BK_WH = 'NO_W8_SUBJ_TO_BK_WH',
  NO_W9_BK_WH_ALL = 'NO_W9_BK_WH_ALL',
  NO_W9_30_DAY_GRACE_PERIOD = 'NO_W9_30_DAY_GRACE_PERIOD',
  NO_W9_BK_WH_DIV_INT = 'NO_W9_BK_WH_DIV_INT',
  VOLUNTARY_DISCLOSURE_SUBJ_BK_WH = 'VOLUNTARY_DISCLOSURE_SUBJ_BK_WH',
  C_NOTICE_BK_WH_DIV_INT = 'C_NOTICE_BK_WH_DIV_INT',
  PRESUMED_FOREIGN_NO_TREATY_BENEFITS = 'PRESUMED_FOREIGN_NO_TREATY_BENEFITS',
  UNCERT_S_CORP = 'UNCERT_S_CORP',
  CERT_S_CORP = 'CERT_S_CORP',
  FIRST_SECOND_B_NOTICE = 'FIRST_SECOND_B_NOTICE',
}

export enum MailingListIndicator {
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
  YEARLY = 'YEARLY',
  RETURNED_THIRD_TIME = 'RETURNED_THIRD_TIME',
  RETURNED_SECOND_TIME = 'RETURNED_SECOND_TIME',
  RETURNED_FIRST_TIME = 'RETURNED_FIRST_TIME',
  DECEASED = 'DECEASED',
}

export enum AccountRestrictionCode {
  LEGAL_RESTRICTION = 'LEGAL_RESTRICTION',
  ACAT_INSTX_RECD = 'ACAT_INSTX_RECD',
  REGT_DAYTRADING_VIOLATION = 'REGT_DAYTRADING_VIOLATION',
  DAYTRADING_VIOLATORS = 'DAYTRADING_VIOLATORS',
  ELECTRONIC_DELIVERY_RESTRICTION = 'ELECTRONIC_DELIVERY_RESTRICTION',
  FROZEN_FOR_90_DAYS = 'FROZEN_FOR_90_DAYS',
  DEPOSIT_ACCT = 'DEPOSIT_ACCT',
  NO_ASSETS_OUT = 'NO_ASSETS_OUT',
  INTERNAL_CONVERSION_IN_PROGRESS = 'INTERNAL_CONVERSION_IN_PROGRESS',
  NO_FUNDS_OUT = 'NO_FUNDS_OUT',
  DO_NOT_DECONVERT = 'DO_NOT_DECONVERT',
  NO_PAPERWORK_ON_FILE = 'NO_PAPERWORK_ON_FILE',
  ACCT_RESTRICTED_MARGIN = 'ACCT_RESTRICTED_MARGIN',
  AML_CIP_RESTRICTION = 'AML_CIP_RESTRICTION',
  CONVERSION_IN_PROGRESS = 'CONVERSION_IN_PROGRESS',
  DECONVERSION_IN_PROGRESS = 'DECONVERSION_IN_PROGRESS',
  EXCESSIVE_RETURN_DEPOSITS = 'EXCESSIVE_RETURN_DEPOSITS',
  LIQUIDATING_ORDERS_ONLY = 'LIQUIDATING_ORDERS_ONLY',
  NO_PAPERWORK_ON_FILE_HARD_RESTRICTION = 'NO_PAPERWORK_ON_FILE_HARD_RESTRICTION',
  RETURNED_MAIL = 'RETURNED_MAIL',
  CLOSED_BY_FIRM = 'CLOSED_BY_FIRM',
  UNKNOWN = 'UNKNOWN',
}

export const AccountRestrictionCodeDisplay: {
  [key in AccountRestrictionCode]: string
} = {
  [AccountRestrictionCode.LEGAL_RESTRICTION]: 'Legal restriction.',
  [AccountRestrictionCode.ACAT_INSTX_RECD]: 'ACAT Instructions Received.',
  [AccountRestrictionCode.REGT_DAYTRADING_VIOLATION]:
    'REG T day trading violation.',
  [AccountRestrictionCode.DAYTRADING_VIOLATORS]: 'Day trading violators.',
  [AccountRestrictionCode.ELECTRONIC_DELIVERY_RESTRICTION]:
    'Electronic delivery restriction.',
  [AccountRestrictionCode.FROZEN_FOR_90_DAYS]: 'Frozen for 90 days.',
  [AccountRestrictionCode.DEPOSIT_ACCT]: 'Deposit account.',
  [AccountRestrictionCode.NO_ASSETS_OUT]: 'No assets out.',
  [AccountRestrictionCode.INTERNAL_CONVERSION_IN_PROGRESS]:
    'Internal conversion in progress. ',
  [AccountRestrictionCode.NO_FUNDS_OUT]: 'No funds out.',
  [AccountRestrictionCode.DO_NOT_DECONVERT]: 'Do not de-convert.',
  [AccountRestrictionCode.NO_PAPERWORK_ON_FILE]: 'No paperwork on file.',
  [AccountRestrictionCode.ACCT_RESTRICTED_MARGIN]: 'Account restricted margin.',
  [AccountRestrictionCode.AML_CIP_RESTRICTION]: 'AML CIP restriction.',
  [AccountRestrictionCode.CONVERSION_IN_PROGRESS]: 'Conversion in progress.',
  [AccountRestrictionCode.DECONVERSION_IN_PROGRESS]:
    'De-conversion in progress.',
  [AccountRestrictionCode.EXCESSIVE_RETURN_DEPOSITS]:
    'Excessive return deposits.',
  [AccountRestrictionCode.LIQUIDATING_ORDERS_ONLY]: 'Liquidating orders only.',
  [AccountRestrictionCode.NO_PAPERWORK_ON_FILE_HARD_RESTRICTION]:
    'No paperwork on file; hard restriction.',
  [AccountRestrictionCode.RETURNED_MAIL]: 'Returned mail.',
  [AccountRestrictionCode.CLOSED_BY_FIRM]: 'Closed by firm.',
  [AccountRestrictionCode.UNKNOWN]: 'Unknown.',
}
